import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './Spinner.styles.js';

var SIZE = 44;
var THICKNESS = 3.6;
var SpinnerPresentation = fComp(function (_ref) {
  var _cleanupClassObject;

  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 60 : _ref$size,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "indeterminate" : _ref$variant;
  var circleStyle = {
    strokeDasharray: "inherit",
    strokeDashoffset: "inherit"
  };
  var isStatic = variant === "static";

  if (isStatic) {
    var circumference = 2 * Math.PI * ((SIZE - THICKNESS) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(hostClass), true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(variant), true), _cleanupClassObject)),
    "aria-valuenow": isStatic ? Math.round(value) : undefined,
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      transform: isStatic ? "rotate(-90deg)" : "inherit"
    },
    role: "progressbar"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React.createElement("circle", {
    style: isStatic ? circleStyle : undefined,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - THICKNESS) / 2,
    fill: "none",
    strokeWidth: THICKNESS
  })));
});

export { SpinnerPresentation };
